import { render, staticRenderFns } from "./BlockSlider.vue?vue&type=template&id=2a61ec7d&"
import script from "./BlockSlider.vue?vue&type=script&lang=js&"
export * from "./BlockSlider.vue?vue&type=script&lang=js&"
import style0 from "./BlockSlider.vue?vue&type=style&index=0&id=2a61ec7d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductCardDefault: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/ProductCard/ProductCardDefault.vue').default})
